module.exports = __webpack_public_path__ + "img/big4-0.65b8c984.jpg";